module.exports = __webpack_public_path__ + "static/media/binge_logo.3ab7183a.png";